




















import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";
import AuthApi from "@/general/api/authApi";

@Component({
  components: {
    IconPointDefault
  },
  store: store
})
export default class IconPoint extends Vue {
  @Prop({ type: [Number, Boolean], default: false }) iconSize!:
    | number
    | boolean;
  @Prop({ type: [Number, Boolean], default: false }) iconSpSize!:
    | number
    | boolean;
  @Prop({ type: String, default: "#ffffff" }) bgColor!: string | boolean;
  @Prop({ type: [String, Boolean], default: false }) iconColor!:
    | string
    | boolean;
  @Prop({ type: [String, Boolean], default: false }) borderColor!:
    | string
    | boolean;
  @Prop({ type: String, default: "custom" }) iconType!: string;

  @Prop({
    type: String,
    default: false
  })
  point_logo!: string;
  point_logo2 = "";

  isSp = globals.isSpScreenWidth;
  colorCode: string | undefined = "";
  point = commons.point;

  //#59042�Ή��ɂ��Z�b�V������񂩂�point_logo���擾����悤�ɏC��
  async created(){
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.point_logo2 = ic_session.pointLogo;
    })
    .catch(() => {
      this.point_logo2 = "";
    });
  }

  getPoint() {
    if (this.point_logo) {
      return this.point_logo;
    }

    //#59042�Ή��ɂ��Z�b�V������񂩂�point_logo���擾����悤�ɏC��
    //if (commons?.OrgPageSpecific?.point_logo) {
    //  return commons?.OrgPageSpecific?.point_logo;
    //}
    //TODO define default point logo.
    //return commons?.OrgPageSpecific?.point_logo;

    return this.point_logo2;
  }

  get iconStyleObject() {
    const { iconSize, iconSpSize, isSp } = this;

    const spIconSize = iconSpSize || iconSize;
    const resultIconSize = isSp ? spIconSize : iconSize;

    const iconStyleObject = {
      width: `${resultIconSize}px`,
      height: `${resultIconSize}px`
    };

    return iconStyleObject;
  }

  get internalIconColor() {
    const colorCode = commons?.OrgPageSpecific?.page_color;

    return {
      iconColor: this.iconColor === false ? colorCode : this.iconColor,
      borderColor: this.borderColor === false ? colorCode : this.borderColor
    };
  }

  get isDefaultIcon() {
    return this.iconType === "default";
  }

  get isCustomIcon() {
    //const point.icon = commons.OrgPageSpecific?.point_logo;
    const iconType = "custom";
    return true;
    //return point.icon !== false && point.icon !== "" && iconType === "custom";
  }
}
